<template>
  <div class="page-content">
    <h1 class="page-title">
      {{ $locale("sideMenu.reports.businessDailyDetail") }}
    </h1>
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="12">
        <CommDatePicker
          v-model="onSearch.searchTime"
          :value.sync="onSearch.searchTime"
          :showWeekly="true"
        />
        <el-button class="egl-btn-yellow" @click="search_fn(false)">{{
          $locale("global.search")
        }}</el-button>
        <el-button class="egl-btn-yellow" @click="search_fn(true)">{{
            $locale("global.getRealData")
          }}</el-button>
      </el-col>
      <el-col :span="12" class="ta-r">
        <el-button
          class="egl-btn-yellow right-align-btn"
          @click="exportCSV"
          >{{ $locale("global.exportToCSV") }}</el-button
        >
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    <div class="checkbox-group">
      <el-row>
        <el-col :span="3">{{
          $locale("trans.report.version.grouping")
        }}</el-col>
        <el-col :span="12">
          <el-checkbox-group v-model="checkboxGroup">
            <el-checkbox label="version">{{
              $locale("global.screenStandard")
            }}</el-checkbox>
            <el-checkbox label="subtitlesVersion">{{
              $locale("trans.report.version.caption")
            }}</el-checkbox>
            <el-checkbox label="otherVersion">{{
              $locale("global.otherVersions")
            }}</el-checkbox>
            <el-checkbox label="unDisplayNoBoxOffice">{{
              $locale("trans.box.freeMobilize")
            }}</el-checkbox>
            <el-checkbox label="unDisplayMobilize">{{
              $locale("trans.box.adjustMobilize")
            }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </div>
    <div id="print">
    <!-- summaryTable -->
    <div class="table-module info-supplement-container">
      <el-row class="module-sms" style="margin: 5px 0;font-size: 16px;">
        <el-col :span="4"
          >{{ $locale("global.cinemaName") }}:{{ cinemaName }}</el-col
        >
        <el-col :span="4"
          >{{ $locale("dailyClosing.createDialog.basicInfo.date") }}:{{
            timeDetail
          }}</el-col
        >
        <el-col :span="4"
          >{{ $locale("trans.report.generatedate") }}:{{
            searchTimeDetail
          }}</el-col
        >
        <el-col :span="8" class="custom-border-table film-table std">
          <el-table
            style="margin-bottom: 0 !important;"
            :data="summaryTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <el-table-column
              v-for="row in summaryTableHeader"
              :key="row.prop"
              :label="row.label"
              :prop="row.prop"
              :formatter="row.formatter"
              align="center"
            />
          </el-table>
        </el-col>
      </el-row>
    </div>
    <!-- ticketTable -->
    <div class="table-module info-supplement-container" style="margin-top: 10px;">
      <el-row class="module-sms" style="margin: 1px 0;">
        <el-col :span="4" class="tableTitle">{{ $locale("cashierReport.dialog.ticket") }}</el-col>
      </el-row>
      <div class="table-container std" style="margin-bottom: 10px;">
        <div style="margin-right: 10px !important;">
          <el-table
            :data="table1"
            class="egl-table list-table boxPeriod"
            border
            @filter-change="filterHandler"
            :span-method="arraySpanMethod"
            :cell-style="cellStyle"
          >
            <template v-for="item in ticketTableHeader">
              <el-table-column
                v-if="isDisplayColumn(item.prop, table1)"
                :key="item.label"
                :label="item.label"
                :prop="item.prop"
                :width="item.width"
                :align="item.subItems ? 'center' : 'left'"
                :filters="item.filters && (item.filters === 'film' ? getFilmNameFilters(ticketTable.todayScheduleRecords): getVersionFilters(ticketTable.todayScheduleRecords, item.filters))"
                :column-key="item.filters && item.filters"
                :formatter="item.formatter"
                class-name="summary"
              >
                <template v-if="item.subItems">
                  <el-table-column
                    v-for="subItem in item.subItems"
                    :key="subItem.label"
                    :label="subItem.label"
                    :prop="item.prop + '.' + subItem.prop"
                    :width="subItem.width"
                    :formatter="subItem.formatter"
                    :align="subItem.subChildItems ? 'center' : 'right'"
                  >
                    <template v-if="subItem.subChildItems">
                      <el-table-column
                        v-for="subChildItem in subItem.subChildItems"
                        :key="subChildItem.label"
                        :label="subChildItem.label"
                        :prop="
                          item.prop + '.' + subItem.prop + '.' + subChildItem.prop
                        "
                        :width="subChildItem.width"
                        :formatter="subChildItem.formatter"
                        align="right"
                      ></el-table-column>
                    </template>
                  </el-table-column>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div>
          <el-table
            :data="ticketTable.todayScheduleRecords"
            class="egl-table list-table boxPeriod"
            border
          >
            <template v-for="item in invitationTableHeader">
              <el-table-column
                v-if="isDisplayColumn(item.prop, ticketTable.todayScheduleRecords)"
                :key="item.label"
                :label="item.label"
                align="center"
              >
                <el-table-column
                  v-for="subItem in item.subItems"
                  :key="subItem.label"
                  :label="subItem.label"
                  align="center"
                >
                  <el-table-column
                    v-for="subChildItem in subItem.subChildItems"
                    :key="subChildItem.label"
                    :label="subChildItem.label"
                    :prop="
                      item.prop + '.' + subItem.prop + '.' + subChildItem.prop
                    "
                    :width="subChildItem.width"
                    :formatter="subChildItem.formatter"
                    align="right"
                  ></el-table-column>
                </el-table-column>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <div class="table-container std" style="margin-bottom: 10px;">
        <!-- preSaleTable -->
        <el-table
          :data="table2"
          class="egl-table list-table boxPeriod"
          border
          @filter-change="filterHandler"
          :span-method="arraySpanMethod2"
          :cell-style="cellStyle2"
        >
          <el-table-column
              v-for="item in preSaleTableHeader"
              :label="item.prop === 'preSale' ? `${$locale('dailyDetail.preSale')} ${$moment(onSearch.searchTime + 86400000).format('M/D')}~${$locale('dailyDetail.show')}`
              :item.label"
              :key="item.prop"
              :prop="item.prop"
              :width="item.width"
              :align="item.subItems ? 'center' : 'left'"
              :filters="item.filters && (item.filters === 'film' ? getFilmNameFilters(ticketTable.nextScheduleRecords): getVersionFilters(ticketTable.nextScheduleRecords, item.filters))"
              :column-key="item.filters && item.filters"
            >
              <template v-if="item.subItems">
                <el-table-column
                  v-for="subItem in item.subItems"
                  :key="subItem.label"
                  :label="subItem.label"
                  :prop="item.prop + '.' + subItem.prop"
                  :width="subItem.width"
                  :formatter="subItem.formatter"
                  :align="subItem.subChildItems ? 'center' : 'left'"
                >
                  <template v-if="subItem.subChildItems">
                    <el-table-column
                      v-for="subChildItem in subItem.subChildItems"
                      :key="subChildItem.label"
                      :label="subChildItem.label"
                      :prop="
                        subItem.prop + '.' + subChildItem.prop
                      "
                      :min-width="subChildItem.width"
                      :formatter="subChildItem.formatter"
                      align="right"
                    ></el-table-column>
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <div class="table-container std" style="margin-bottom: 10px;">
        <div>
          <el-table
            :data="paymentTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <el-table-column
              v-for="item in paymentMethodTableHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :formatter="item.formatter"
              :min-width="item.width"
              :align="item.align"
            >
              <template slot-scope="scope" >
                <p v-if="item.prop === 'seatTotal' && scope.$index === paymentTable.length - 1">{{ toThousands(getTotalFn(paymentTable)) + '円' }}</p>
                <p v-else-if="item.prop === 'seatTotal'">{{ toThousands(parseInt(scope.row.seatTotal) + parseInt(scope.row.versionTotal)) + '円' }}</p>
                <p v-else>{{ item.prop === 'total' ? toThousands(scope.row[item.prop]) + '円' :  scope.row[item.prop] }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-table
            :data="paymentRefundTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <el-table-column
              v-for="item in paymentMethodRefundTableHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :formatter="item.formatter"
              :min-width="item.width"
              :align="item.align"
            >
              <template slot-scope="scope" >
                <p v-if="item.prop === 'seatTotal' && scope.$index === paymentTable.length - 1">{{ getTotalFn(paymentRefundTable) }}</p>
                <p v-else-if="item.prop === 'seatTotal'">{{ parseInt(scope.row.seatTotal) + parseInt(scope.row.versionTotal) }}</p>
                <p v-else>{{ scope.row[item.prop] }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-table
            :data="couponReceivableTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <el-table-column
              v-for="item in couponReceivableTableHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :formatter="item.formatter"
              :min-width="item.width"
              :align="item.align"
            ></el-table-column>
          </el-table>
        </div>
        <div>
          <el-table
            :data="dayCashSalesTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <el-table-column
              v-for="item in dayCashSalesHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :formatter="item.formatter"
              :min-width="item.width"
              :align="item.align"
            ></el-table-column>
          </el-table>
        </div>
        <div>
          <el-table
            :data="paymentTicketItems"
            class="egl-table list-table boxPeriod"
            border
          >
            <el-table-column
              v-for="item in paymentTicketItemsHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :formatter="item.formatter"
              :min-width="item.width"
              :align="item.align"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- shop -->
    <div class="table-module info-supplement-container" style="margin-top: 10px;">
      <el-row class="module-sms" style="margin: 1px 0;">
        <el-col :span="4" class="tableTitle">{{ $locale("dailyDetail.shop") }}</el-col>
      </el-row>
      <div class="table-container std" style="margin-bottom: 0;">
        <div>
          <el-table
            :data="salesTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <template v-for="item in shopSalesTableHeader">
              <el-table-column
                v-if="isDisplayColumn(item.prop, salesTable)"
                :label="item.label"
                :key="item.label"
                :prop="item.prop"
                :width="item.prop === 'salesGroup' ? item.width : 140"
                :formatter="item.formatter"
                :align="item.align"
              >
              <template v-if="item.subItems">
                <el-table-column
                  v-for="subItem in item.subItems"
                  :key="subItem.label"
                  :label="subItem.label"
                  :prop="item.prop + '.' + subItem.prop"
                  :width="subItem.width"
                  :formatter="subItem.formatter"
                  :align="subItem.subChildItems ? 'center' : 'right'"
                ></el-table-column>
              </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div v-if="!$_.isEmpty(paymentRecordsTable)">
          <el-table
            :data="paymentRecordsTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <template v-for="item in shopPaymentTableHeader">
              <el-table-column
                v-if="isDisplayColumn(item.prop, paymentRecordsTable)"
                :label="item.label"
                :key="item.label"
                :prop="item.prop"
                :width="item.width"
                :formatter="item.formatter"
                :align="item.align"
              >
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div>
          <el-table
            v-if="!$_.isEmpty(paymentRefundRecordsTable)"
            :data="paymentRefundRecordsTable"
            class="egl-table list-table boxPeriod"
            border
          >
            <template v-for="item in shopPaymentRefundTableHeader">
              <el-table-column
                v-if="isDisplayColumn(item.prop, paymentRefundRecordsTable)"
                :label="item.label"
                :key="item.label"
                :prop="item.prop"
                :width="item.width"
                :formatter="item.formatter"
                :align="item.align"
              >
              </el-table-column>
          </template>
          </el-table>
        </div>
      </div>
    </div>
    <!-- otherRevenue -->
    <div class="table-module info-supplement-container" style="margin-top: 10px;">
      <el-row class="module-sms" style="margin: 1px 0;">
        <el-col :span="4" class="tableTitle">{{ $locale("dailyDetail.otherRevenue") }}</el-col>
      </el-row>
      <div class="table-container std">
        <template v-for="table in otherRevenueArr">
          <div  :key="table.title" v-if="otherRevenueTable[table.data].length > 0">
            <p>{{table.title}}</p>
            <el-table
              :data="otherRevenueTable[table.data]"
              class="egl-table list-table boxPeriod"
              border
            >
              <el-table-column
                v-for="header in table.labels"
                :label="header.label"
                :key="header.prop"
                :prop="header.prop"
                :width="header.width"
                :formatter="header.formatter"
                :align="header.align"
              >
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import CommDatePicker from "@/components/common/CommDatePicker";
import {
  priceFormat,
  summaryTableHeader,
  ticketTableHeader,
  invitationTableHeader,
  preSaleTableHeader,
  paymentMethodTableHeader,
  paymentMethodRefundTableHeader,
  couponReceivableTableHeader,
  shopSalesTableHeader,
  shopPaymentTableHeader,
  shopPaymentRefundTableHeader,
  accountsRecoveryTableHeader,
  otherCashRecovery,
  accountsPaymentTableHeader,
  otherCashPaymentTableHeader,
  salesAccountsTableHeader,
  dayCashSalesHeader,
  paymentTicketItemsHeader,
  filterPayPayData,
  countLeafColumns,
} from "@/assets/js/businessDailyDetail";
import { getDailySalesDetailList } from "@/helpers/service/api/report";
import { exportCSV_fn } from "@/assets/js/businessDailyDetail_exportCSV";
import { toThousands } from "@/utils/common";
// mock
import { getBoxOfficeDetailList } from "@/helpers/service/api/mock";

import filterOptions from "@/mixins/filterOptions";
import { localStorage } from '@/utils/localStorage'
import { saveFilterOptions } from "@/utils/filterOptions";

export default {
  mixins: [ filterOptions ],
  created() {
    // getBoxOfficeDetailList().then(res => {
    //   console.log(res);
    // });
  },
  async mounted() {
    await this.loadOptions('business-daily-detail', (val) => {
      // this.onSearch = val.options.onSearch;
      this.checkboxGroup = val.options.checkboxGroup;
    })
    this.getList(false);
  },
  data() {
    return {
      onSearch: {
        searchTime: this.$moment().startOf("day").valueOf(),
      },
      checkboxGroup: [],
      cinemaName: "",
      searchTimeDetail: "",
      timeDetail: "",
      hasPayPay: false, // PayPay 列表示切替。API 応答前は非表示とし、応答で true のとき表示（表示→非表示のちらつき防止）。DEV-14574
      ticketTableHeader: ticketTableHeader(false),
      summaryTableHeader: summaryTableHeader(),
      invitationTableHeader: invitationTableHeader(),
      preSaleTableHeader: preSaleTableHeader(false),
      paymentMethodTableHeader: paymentMethodTableHeader(),
      paymentMethodRefundTableHeader: paymentMethodRefundTableHeader(),
      couponReceivableTableHeader: couponReceivableTableHeader(),
      dayCashSalesHeader: dayCashSalesHeader(),
      paymentTicketItemsHeader: paymentTicketItemsHeader(),
      shopSalesTableHeader: shopSalesTableHeader(false),
      shopPaymentTableHeader: shopPaymentTableHeader(),
      shopPaymentRefundTableHeader: shopPaymentRefundTableHeader(),
      summaryTable: [],
      ticketTable: {
        todayScheduleRecords: [],
        nextScheduleRecords: [],
      },
      todayScheduleRecords: [],
      invitationTable: [],
      nextScheduleRecords: [],
      shopTable: {},
      salesTable: [],
      paymentRecordsTable: [],
      paymentRefundRecordsTable: [],
      otherRevenueTable: {
        AccountsRecoveryTable: [],
        CashRecoveryTable: [],
        AccountsPaymentTable: [],
        CashPaymentTable: [],
        SalesAccountsTable: [],
      },
      otherRevenueArr: [
        {
          title: this.$locale("dailyDetail.otherRevenue.accountsRecovery"),
          labels: accountsRecoveryTableHeader(),
          data: "AccountsRecoveryTable"
        },
        {
          title: this.$locale("dailyDetail.otherRevenue.otherCashRecovery"),
          labels: otherCashRecovery(),
          data: "CashRecoveryTable"
        },
        {
          title: this.$locale("dailyDetail.otherRevenue.accountsPayment"),
          labels: accountsPaymentTableHeader(),
          data: "AccountsPaymentTable"
        },
        {
          title: this.$locale("dailyDetail.otherRevenue.otherCashPayment"),
          labels: otherCashPaymentTableHeader(),
          data: "CashPaymentTable"
        },
        {
          title: this.$locale("dailyDetail.otherRevenue.salesAccounts"),
          labels: salesAccountsTableHeader(),
          data: "SalesAccountsTable"
        }
      ],
      paymentTable: [],
      paymentRefundTable: [],
      priceFormat,
      ticketFilter: {},
      couponReceivableTable: [],
      dayCashSalesTable: [
      {
        dayCashName: "現金収入",
          total: 0
        },
        {
          dayCashName: "売掛金現金回収",
          total: 0
        },
        {
          dayCashName: "買掛金現金支払",
          total: 0
        },
        {
          dayCashName: "その他仕入 現金支払",
          total: 0
        },
        {
          dayCashName: "合計",
          total: 0
        }
      ],
      paymentTicketItems: [],
      printObj: {
        popTitle: this.$locale("sideMenu.reports.businessDailyDetail"),
        id: "print",
      },
      toThousands,
    };
  },
  methods: {
    getTotalFn(data) {
      let number = 0
      data.forEach((item, idx) => {
        if (idx < data.length - 1) {
          number += (item.seatTotal + item.versionTotal)
        }
      });
      return number
    },
    getDetailData(data, loopKey, dataKey, type = "today") {
      let _arr = [];
      data.forEach(item => {
        item[loopKey].forEach(version => {
          if (type === "today") {
            _arr.push({
              filmName: item.filmName,
              version: version.version,
              subtitlesVersion: version.subtitlesVersion,
              otherVersion: version.otherVersion,
              scheduleSalesGroup: version.scheduleSalesGroup,
              seatPrice: version.seatPrice,
              officeBox: version.officeBox,
              online: version.online,
              advanceTicket: version.advanceTicket,
              nationalTicket: version.nationalTicket,
              coupon: version.coupon,
              invitation: version.invitation
            });
          } else {
            _arr.push({
              filmName: item.filmName,
              version: version.version,
              subtitlesVersion: version.subtitlesVersion,
              otherVersion: version.otherVersion,
              cashNext: version.cashNext,
              creditNext: version.creditNext,
              payPayNext: version.payPayNext,
              onlineNext: version.onlineNext,
              advanceTicketNext: version.advanceTicketNext,
              nationalTicketNext: version.nationalTicketNext,
              couponNext: version.couponNext,
              invitationNext: version.invitationNext
            });
          }
        });
      });
      this.ticketTable[dataKey] = _arr;
    },
    accumated(data, key) {
      return data.reduce((pre, cur) => {
        // if (key === 'dayBeforePreSale' || key === 'dayPreSaleTotal') {
        //   return Object.values(cur[key]).reduce((preValue, curValue) => {
        //     return preValue + curValue;
        //   }, 0);
        // }
        return pre + cur[key];
      }, 0);
    },
    paymentcalcTotal(data,apiData, type) {
      data.push({
        ...type && type === "coupon" ? { couponName: this.$locale("pdfFilmFeeBalance.th.total") } : { paymentName: this.$locale("pdfFilmFeeBalance.th.total") },
        visitor: this.accumated(apiData, "visitor"),
        total: this.accumated(apiData, "total"),
        ...type && type === "shop" ? {
          seatTotal: this.accumated(apiData, "seatTotal"),
        } : {}
      });
    },
    search_fn(isToday) {
      if(isToday) {
        this.onSearch.searchTime = this.$moment().startOf("day").valueOf();
      }
      saveFilterOptions({
        id: localStorage.get('loginAsAccountId') || localStorage.get('accountId'),
        options: {
          // onSearch: this.onSearch,
          checkboxGroup: this.checkboxGroup,
        }
      }, 'business-daily-detail')
      this.getList(isToday);
    },
    getList(isToday = false) {
      getDailySalesDetailList({
        realtime: isToday,
        cinemaId: window.localStorage.getItem("cinemaId"),
        date: isToday ? this.$moment().format("YYYY-MM-DD") : this.$moment(this.onSearch.searchTime).format("YYYY-MM-DD"),
        version: this.checkboxGroup.indexOf("version") > -1,
        subtitlesVersion: this.checkboxGroup.indexOf("subtitlesVersion") > -1,
        otherVersion: this.checkboxGroup.indexOf("otherVersion") > -1,
        unDisplayMobilize: this.checkboxGroup.indexOf("unDisplayMobilize") > -1,
        unDisplayNoBoxOffice: !(this.checkboxGroup.indexOf("unDisplayNoBoxOffice") > -1),
      }).then(res => {
        // console.log(res.data);
        this.summaryTable = [];
        function getTotal_fn(arr, type, subType, key) {
          return arr.reduce((total, item) => total + item[type][subType][key], 0);
        }
        function getTotalNext_fn(arr, type, key) {
          return arr.reduce((total, item) => total + item[type][key], 0);
        }
        if (res.data) {
          this.cinemaName = res.data.cinema;
          // PayPay 列表示切替: cinema の支払方法設定に基づき表頭を再構築。DEV-14574
          // hasPayPay が欠落（旧 backend）の場合は true で現行挙動を維持
          this.hasPayPay = res.data.hasPayPay !== undefined && res.data.hasPayPay !== null ? res.data.hasPayPay : true;
          this.ticketTableHeader = ticketTableHeader(this.hasPayPay);
          this.preSaleTableHeader = preSaleTableHeader(this.hasPayPay);
          this.shopSalesTableHeader = shopSalesTableHeader(this.hasPayPay);
          this.searchTimeDetail = this.$moment(res.data.exportAt).format("YYYY-MM-DD HH:mm:ss");
          this.timeDetail = this.$moment(res.data.reportOf).format("YYYY-MM-DD");
          if (res.data.month) {
            this.summaryTable.push(res.data.month);
          }
          if (res.data.ticket) {
            const {
              ticket: {
                nextScheduleRecords,
                todayScheduleRecords,
                paymentRecords,
                paymentRefundRecords,
                couponReceivables
              }
            } = res.data;

            if(todayScheduleRecords && todayScheduleRecords.length > 0) {
              this.getDetailData(todayScheduleRecords, "versionRecords", "todayScheduleRecords");
              // 增加合计
              this.ticketTable.todayScheduleRecords.push({
                filmName: "合計",
                version: "",
                subtitlesVersion: "",
                otherVersion: "",
                scheduleSalesGroup: {
                  boxOffice: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "boxOffice", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "boxOffice", "total"),
                  },
                  morningShow: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "morningShow", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "morningShow", "total"),
                  },
                  lateShow: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "lateShow", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "lateShow", "total"),
                  },
                  allNight: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "allNight", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "allNight", "total"),
                  },
                  special: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "special", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "special", "total"),
                  },
                  accumulated: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "accumulated", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "scheduleSalesGroup", "accumulated", "total"),
                  }
                },
                seatPrice: {
                  after: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "seatPrice", "after", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "seatPrice", "after", "total"),
                  },
                  before: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "seatPrice", "before", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "seatPrice", "before", "total"),
                  }
                },
                officeBox: {
                  todayCash: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "todayCash", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "todayCash", "total"),
                  },
                  todayCredit: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "todayCredit", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "todayCredit", "total"),
                  },
                  todayPayPay: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "todayPayPay", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "todayPayPay", "total"),
                  },
                  beforeCash: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "beforeCash", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "beforeCash", "total"),
                  },
                  beforeCredit: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "beforeCredit", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "beforeCredit", "total"),
                  },
                  beforePayPay: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "beforePayPay", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "officeBox", "beforePayPay", "total"),
                  }

                },
                online: {
                  today: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "online", "today", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "online", "today", "total"),
                  },
                  before: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "online", "before", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "online", "before", "total"),
                  },
                },
                advanceTicket: {
                  today: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "advanceTicket", "today", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "advanceTicket", "today", "total"),
                  },
                  before: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "advanceTicket", "before", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "advanceTicket", "before", "total"),
                  }
                },
                nationalTicket: {
                  today: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "nationalTicket", "today", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "nationalTicket", "today", "total"),
                  },
                  before: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "nationalTicket", "before", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "nationalTicket", "before", "total"),
                  }
                },
                coupon: {
                  today: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "coupon", "today", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "coupon", "today", "total"),
                  },
                  before: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "coupon", "before", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "coupon", "before", "total"),
                  }
                },
                invitation: {
                  today: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "invitation", "today", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "invitation", "today", "total"),
                  },
                  before: {
                    visitor: getTotal_fn(this.ticketTable.todayScheduleRecords, "invitation", "before", "visitor"),
                    total: getTotal_fn(this.ticketTable.todayScheduleRecords, "invitation", "before", "total"),
                  },
                },
              });
              // this.ticketTable.todayScheduleRecords.forEach(item => {
              //   delete item.scheduleSalesGroup.accumulated.visitor;
              // });
            } else {
              this.ticketTable.todayScheduleRecords = [];
            }
            if(nextScheduleRecords && nextScheduleRecords.length > 0) {
              this.getDetailData(nextScheduleRecords, "versionRecordsNext", "nextScheduleRecords", "next");
              // 增加合计
              this.ticketTable.nextScheduleRecords.push({
                filmName: "合計",
                version: "",
                subtitlesVersion: "",
                otherVersion: "",
                cashNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "cashNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "cashNext", "total"),
                },
                creditNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "creditNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "creditNext", "total"),
                },
                payPayNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "payPayNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "payPayNext", "total"),
                },
                onlineNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "onlineNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "onlineNext", "total"),
                },
                advanceTicketNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "advanceTicketNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "advanceTicketNext", "total"),
                },
                nationalTicketNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "nationalTicketNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "nationalTicketNext", "total"),
                },
                couponNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "couponNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "couponNext", "total"),
                },
                invitationNext: {
                  visitor: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "invitationNext", "visitor"),
                  total: getTotalNext_fn(this.ticketTable.nextScheduleRecords, "invitationNext", "total"),
                },
              });
            } else {
              this.ticketTable.nextScheduleRecords = [];
            }
            this.paymentTable = paymentRecords;
            if(paymentRecords && paymentRecords.length > 0) {
              this.paymentcalcTotal(this.paymentTable, paymentRecords, "shop");
            }

            this.paymentRefundTable = paymentRefundRecords;
            if(paymentRefundRecords && paymentRefundRecords.length > 0) {
              this.paymentcalcTotal(this.paymentRefundTable, paymentRefundRecords, "shop");
            }

            this.couponReceivableTable = couponReceivables;
            if(couponReceivables && couponReceivables.length > 0) {
              this.paymentcalcTotal(this.couponReceivableTable, couponReceivables, "coupon");
            }
          } else {
            this.ticketTable = {
              todayScheduleRecords: [],
              nextScheduleRecords: []
            };
            this.paymentTable = [];
            this.paymentRefundTable = [];
            this.couponReceivableTable = [];
          }
          if (res.data.store) {
            const {
              store: {
                paymentRecordsStore,
                paymentRefundRecordsStore,
                sales,
              }
            } = res.data;
            this.salesTable = sales;
            this.paymentRecordsTable = paymentRecordsStore;
            this.paymentRefundRecordsTable = paymentRefundRecordsStore;
            if(sales.length > 0) {
              this.salesTable.push({
                salesGroup: this.$locale("pdfFilmFeeBalance.th.total"),
                dayNon: {
                  cash: sales.reduce((pre, cur) => pre + (cur.dayNon?.cash || 0), 0),
                  credit: sales.reduce((pre, cur) => pre + (cur.dayNon?.credit || 0), 0),
                  paypay: sales.reduce((pre, cur) => pre + (cur.dayNon?.paypay || 0), 0),
                  online: sales.reduce((pre, cur) => pre + (cur.dayNon?.online || 0), 0),
                },
                dayZero: {
                  cash: sales.reduce((pre, cur) => pre + (cur.dayZero?.cash || 0), 0),
                  credit: sales.reduce((pre, cur) => pre + (cur.dayZero?.credit || 0), 0),
                  paypay: sales.reduce((pre, cur) => pre + (cur.dayZero?.paypay || 0), 0),
                  online: sales.reduce((pre, cur) => pre + (cur.dayZero?.online || 0), 0),
                },
                dayEight: {
                  cash: sales.reduce((pre, cur) => pre + (cur.dayEight?.cash || 0), 0),
                  credit: sales.reduce((pre, cur) => pre + (cur.dayEight?.credit || 0), 0),
                  paypay: sales.reduce((pre, cur) => pre + (cur.dayEight?.paypay || 0), 0),
                  online: sales.reduce((pre, cur) => pre + (cur.dayEight?.online || 0), 0),
                },
                dayTen: {
                  cash: sales.reduce((pre, cur) => pre + (cur.dayTen?.cash || 0), 0),
                  credit: sales.reduce((pre, cur) => pre + (cur.dayTen?.credit || 0), 0),
                  paypay: sales.reduce((pre, cur) => pre + (cur.dayTen?.paypay || 0), 0),
                  online: sales.reduce((pre, cur) => pre + (cur.dayTen?.online || 0), 0),
                },
                dayTotal: this.accumated(sales, "dayTotal"),
                monthNon: this.accumated(sales, "monthNon"),
                monthZero: this.accumated(sales, "monthZero"),
                monthEight: this.accumated(sales, "monthEight"),
                monthTen: this.accumated(sales, "monthTen"),
                monthTotal: this.accumated(sales, "monthTotal"),
                // dayBeforePreSale: this.accumated(sales, 'dayBeforePreSale'),
                // dayPreSaleTotal: this.accumated(sales, 'dayPreSaleTotal'),
                dayBeforePreSale: {
                  cash: sales.reduce((pre, cur) => pre + cur.dayBeforePreSale.cash, 0),
                  credit: sales.reduce((pre, cur) => pre + cur.dayBeforePreSale.credit, 0),
                  paypay: sales.reduce((pre, cur) => pre + cur.dayBeforePreSale.paypay, 0),
                  online: sales.reduce((pre, cur) => pre + cur.dayBeforePreSale.online, 0),
                },
                dayPreSaleTotal: {
                  cash: sales.reduce((pre, cur) => pre + (cur.dayPreSaleTotal.cash || 0), 0),
                  credit: sales.reduce((pre, cur) => pre + (cur.dayPreSaleTotal.credit || 0), 0),
                  paypay: sales.reduce((pre, cur) => pre + (cur.dayPreSaleTotal.paypay || 0), 0),
                  online: sales.reduce((pre, cur) => pre + (cur.dayPreSaleTotal.online || 0), 0),
                }
              });
            }
            if (paymentRecordsStore.length > 0) {
              this.paymentcalcTotal(this.paymentRecordsTable, paymentRecordsStore);
            }
            if (paymentRefundRecordsStore.length > 0) {
              this.paymentcalcTotal(this.paymentRefundRecordsTable, paymentRefundRecordsStore);
            }
          } else {
            this.salesTable = [];
            this.paymentRecordsTable = [];
            this.paymentRefundRecordsTable = [];
          }
          if (res.data.otherRevenue) {
            const {
              otherRevenue: {
                accountsPayment,
                accountsRecovery,
                otherCashPayment,
                otherCashesRecovery,
                salesAccounts
              }
            } = res.data;
            this.otherRevenueTable = {
              AccountsRecoveryTable: accountsRecovery,
              CashRecoveryTable: otherCashesRecovery,
              AccountsPaymentTable: accountsPayment,
              CashPaymentTable: otherCashPayment,
              SalesAccountsTable: salesAccounts,
            };
            if (accountsRecovery.length > 0) {
              this.otherRevenueTable.AccountsRecoveryTable.push({
                requestName: this.$locale("pdfFilmFeeBalance.th.total"),
                requestDetails: "",
                mount: this.accumated(accountsRecovery, "mount")
              });
            }
            if (otherCashesRecovery.length > 0) {
              this.otherRevenueTable.CashRecoveryTable.push({
                clientName: this.$locale("pdfFilmFeeBalance.th.total"),
                otherRevenueName: "",
                cashRecovery: this.accumated(otherCashesRecovery, "cashRecovery")
              });
            }
            if (accountsPayment.length > 0) {
              this.otherRevenueTable.AccountsPaymentTable.push({
                requestName: this.$locale("pdfFilmFeeBalance.th.total"),
                requestDetails: "",
                cashRecoveryAmount: this.accumated(accountsPayment, "cashRecoveryAmount")
              });
            }
            if (otherCashPayment.length > 0) {
              this.otherRevenueTable.CashPaymentTable.push({
                clientName: this.$locale("pdfFilmFeeBalance.th.total"),
                otherGoodsName: "",
                cashRecovery: this.accumated(otherCashPayment, "cashRecovery")
              });
            }
            if (salesAccounts.length > 0) {
              this.otherRevenueTable.SalesAccountsTable.push({
                clientName: this.$locale("pdfFilmFeeBalance.th.total"),
                otherRevenueName: "",
                cashRecovery: this.accumated(salesAccounts, "cashRecovery")
              });
            }
          } else {
            this.otherRevenueTable = {
              AccountsRecoveryTable: [],
              CashRecoveryTable: [],
              AccountsPaymentTable: [],
              CashPaymentTable: [],
              SalesAccountsTable: [],
            };
          }
        }
        const keys = ["cashSales", "cashAccountsReceivable", "cashPayAccountsPayable", "cashPayOtherRevenue", "total"]
        this.dayCashSalesTable.forEach((item, idx) => {
          this.dayCashSalesTable[idx].total = res.data.dayCashSales[keys[idx]] ? res.data.dayCashSales[keys[idx]] : 0
        })

        if (res.data.paymentTicketItems && res.data.paymentTicketItems.length > 0) {
          this.paymentTicketItems = [
            ...res.data.paymentTicketItems,
            {
              paymentName: "合計",
              visitor: this.$_.sumBy(res.data.paymentTicketItems, "visitor"),
              total: this.$_.sumBy(res.data.paymentTicketItems, "total"),
            }
          ];
        } else {
          this.paymentTicketItems = [];
        }
      });
    },
    getPaymentMethodData(dataArray) {
      let _data = JSON.parse(JSON.stringify(dataArray));
      const [paymentTable, paymentRefundTable, couponReceivableTable, dayCashSalesTable, paymentTicketItems] = _data;
      const maxArray = this.$_.maxBy(_data, function(arr) { return arr.length; });
      let _resultArray = [];
      maxArray.forEach((item, idx) => {
        _resultArray.push({
          paymentName: paymentTable[idx] ?  paymentTable[idx].paymentName : "",
          visitor: paymentTable[idx] ?  paymentTable[idx].visitor : "",
          total: paymentTable[idx] ?  paymentTable[idx].total : "",
          seatTotal: idx === paymentTable.length - 1 ? this.getTotalFn(paymentTable) : (paymentTable[idx] ?  paymentTable[idx].seatTotal + paymentTable[idx].versionTotal : ""),
          paymentNameRefund: paymentRefundTable[idx] ?  paymentRefundTable[idx].paymentName : "",
          visitorRefund: paymentRefundTable[idx] ?  paymentRefundTable[idx].visitor : "",
          totalRefund: paymentRefundTable[idx] ?  paymentRefundTable[idx].total : "",
          seatTotalRefund: idx === paymentRefundTable.length - 1 ? this.getTotalFn(paymentRefundTable) : (paymentRefundTable[idx] ?  paymentRefundTable[idx].seatTotal + paymentRefundTable[idx].versionTotal : ""),
          couponName: couponReceivableTable[idx] ? couponReceivableTable[idx].couponName : "",
          couponVisitor: couponReceivableTable[idx] ? couponReceivableTable[idx].visitor : "",
          couponTotal: couponReceivableTable[idx] ? couponReceivableTable[idx].total : "",
          dayCashName: dayCashSalesTable[idx] ? dayCashSalesTable[idx].dayCashName : "",
          dayCashTotal: dayCashSalesTable[idx] ? dayCashSalesTable[idx].total : "",
          paymentTicketName: paymentTicketItems[idx] ? paymentTicketItems[idx].paymentName : "",
          paymentTicketVisitor: paymentTicketItems[idx] ? paymentTicketItems[idx].visitor : "",
          paymentTicketTotal: paymentTicketItems[idx] ? paymentTicketItems[idx].total : "",
        });
      });
      return _resultArray;
    },
    getShopData(dataArray) {
      let _data = JSON.parse(JSON.stringify(dataArray));
      const [salesTable, paymentRecordsTable, paymentRefundRecordsTable] = _data;
      const maxArray = this.$_.maxBy(_data, function(arr) { return arr.length; });
      let _resultArray = [];
      maxArray.forEach((item, idx) => {
        _resultArray.push({
          salesGroup: salesTable[idx] ? salesTable[idx].salesGroup : "",
          dayEight: {
            cash: salesTable[idx] ? salesTable[idx].dayEight.cash : "",
            credit: salesTable[idx] ? salesTable[idx].dayEight.credit : "",
            paypay: salesTable[idx] ? salesTable[idx].dayEight.paypay : "",
            online: salesTable[idx] ? salesTable[idx].dayEight.online : "",
          },
          dayTen: {
            cash: salesTable[idx] ? salesTable[idx].dayTen.cash : "",
            credit: salesTable[idx] ? salesTable[idx].dayTen.credit : "",
            paypay: salesTable[idx] ? salesTable[idx].dayTen.paypay : "",
            online: salesTable[idx] ? salesTable[idx].dayTen.online : "",
          },
          dayNon: {
            cash: salesTable[idx] ? salesTable[idx].dayNon.cash : "",
            credit: salesTable[idx] ? salesTable[idx].dayNon.credit : "",
            paypay: salesTable[idx] ? salesTable[idx].dayNon.paypay : "",
            online: salesTable[idx] ? salesTable[idx].dayNon.online : "",
          },
          dayZero: {
            cash: salesTable[idx] ? salesTable[idx].dayZero.cash : "",
            credit: salesTable[idx] ? salesTable[idx].dayZero.credit : "",
            paypay: salesTable[idx] ? salesTable[idx].dayZero.paypay : "",
            online: salesTable[idx] ? salesTable[idx].dayZero.online : "",
          },
          dayBeforePreSale: {
            cash: salesTable[idx] ? salesTable[idx].dayBeforePreSale.cash : "",
            credit: salesTable[idx] ? salesTable[idx].dayBeforePreSale.credit : "",
            paypay: salesTable[idx] ? salesTable[idx].dayBeforePreSale.paypay : "",
            online: salesTable[idx] ? salesTable[idx].dayBeforePreSale.online : "",
          },
          dayTotal: salesTable[idx] ? salesTable[idx].dayTotal : "",
          dayPreSaleTotal: {
            cash: salesTable[idx] ? salesTable[idx].dayPreSaleTotal.cash : "",
            credit: salesTable[idx] ? salesTable[idx].dayPreSaleTotal.credit : "",
            paypay: salesTable[idx] ? salesTable[idx].dayPreSaleTotal.paypay : "",
            online: salesTable[idx] ? salesTable[idx].dayPreSaleTotal.online : "",
          },
          monthNon: salesTable[idx] ? salesTable[idx].monthNon : "",
          monthZero: salesTable[idx] ? salesTable[idx].monthZero : "",
          monthEight: salesTable[idx] ? salesTable[idx].monthEight : "",
          monthTen: salesTable[idx] ? salesTable[idx].monthTen : "",
          monthTotal: salesTable[idx] ? salesTable[idx].monthTotal : "",
          emptyColumn: "",
          paymentName: paymentRecordsTable[idx] ? paymentRecordsTable[idx].paymentName : "",
          visitor: paymentRecordsTable[idx] ? paymentRecordsTable[idx].visitor : "",
          total: paymentRecordsTable[idx] ? paymentRecordsTable[idx].total : "",
          emptyColumn2: "",
          paymentNameRefund: paymentRefundRecordsTable[idx] ? paymentRefundRecordsTable[idx].paymentName: "",
          visitorRefund: paymentRefundRecordsTable[idx] ? paymentRefundRecordsTable[idx].visitor: "",
          totalRefund: paymentRefundRecordsTable[idx] ? paymentRefundRecordsTable[idx].total: "",
        });
      });
      return _resultArray;
    },
    getCouponData(dataArray) {
      let _data = JSON.parse(JSON.stringify(dataArray));
      const [ couponReceivableTable, dayCashSalesTable ] = _data;
      const maxArray = this.$_.maxBy(_data, function(arr) { return arr.length; });
      let _resultArray = [];
      maxArray.forEach((item, idx) => {
        _resultArray.push({
          couponName: couponReceivableTable[idx] ? couponReceivableTable[idx].couponName : "",
          visitor: couponReceivableTable[idx] ? couponReceivableTable[idx].visitor : "",
          total: couponReceivableTable[idx] ? couponReceivableTable[idx].total : "",
          emptyColumn: "",
          dayCashName: dayCashSalesTable[idx] ? dayCashSalesTable[idx].dayCashName : "",
          dayCashtotal: dayCashSalesTable[idx] ? dayCashSalesTable[idx].total : "",
        });
      });
      console.log(_resultArray)
      return _resultArray;
    },
    getOtherRevenueData(dataArray) {
      let _data = JSON.parse(JSON.stringify(dataArray));
      const [AccountsRecoveryTable, CashRecoveryTable, AccountsPaymentTable, CashPaymentTable, SalesAccountsTable] = _data;
      const maxArray = this.$_.maxBy(_data, function(arr) { return arr.length; });
      let _resultArray = [];
      maxArray.forEach((item, idx) => {
        _resultArray.push({
          requestName: AccountsRecoveryTable[idx] ? AccountsRecoveryTable[idx].requestName : "",
          requestDetails: AccountsRecoveryTable[idx] ? AccountsRecoveryTable[idx].requestDetails : "",
          cashRecoveryAmount: AccountsRecoveryTable[idx] ? AccountsRecoveryTable[idx].mount : "",
          emptyColumn: "",

          clientName: CashRecoveryTable[idx] ? CashRecoveryTable[idx].clientName : "",
          otherRevenueName: CashRecoveryTable[idx] ? CashRecoveryTable[idx].otherRevenueName : "",
          cashRecovery: CashRecoveryTable[idx] ? CashRecoveryTable[idx].cashRecovery : "",
          emptyColumn2: "",

          requestNamePayment: AccountsPaymentTable[idx] ? AccountsPaymentTable[idx].requestName : "",
          requestDetailsPayment: AccountsPaymentTable[idx] ? AccountsPaymentTable[idx].requestDetails : "",
          cashRecoveryAmountPayment: AccountsPaymentTable[idx] ? AccountsPaymentTable[idx].cashRecoveryAmount : "",
          emptyColumn3: "",

          clientNamePayment: CashPaymentTable[idx] ? CashPaymentTable[idx].clientName : "",
          otherRevenueNamePayment: CashPaymentTable[idx] ? CashPaymentTable[idx].otherGoodsName : "",
          cashRecoveryPayment: CashPaymentTable[idx] ? CashPaymentTable[idx].cashRecovery : "",
          emptyColumn4: "",

          clientNameSales: SalesAccountsTable[idx] ? SalesAccountsTable[idx].clientName : "",
          otherRevenueNameSales: SalesAccountsTable[idx] ? SalesAccountsTable[idx].otherRevenueName : "",
          cashRecoverySales: SalesAccountsTable[idx] ? SalesAccountsTable[idx].cashRecovery : "",
        });
      });
      return _resultArray;
    },
    exportCSV() {
      // let basic = {
      //   ticketTableHeader: this.ticketTableHeader,
      //   invitationTableHeader: this.invitationTableHeader
      // };
      // this.getExportCSVData();
      let data = {
        summary: {
          header: this.summaryTableHeader,
          data: this.summaryTable,
        },
        todayTicket: {
          header: [this.ticketTableHeader, this.invitationTableHeader],
          // 不支持 PayPay 的影院，从数据行中也剔除 PayPay 值，使其与已剔除的表头列对齐。DEV-14700
          data: this.hasPayPay
            ? this.ticketTable.todayScheduleRecords
            : filterPayPayData(this.ticketTable.todayScheduleRecords),
          // 招待券表格前的空列分隔位置。PayPay 列的有无会改变叶子列数，故动态计算。DEV-14700
          pos: countLeafColumns(this.ticketTableHeader),
        },
        nextTicket: {
          header: this.preSaleTableHeader,
          // 不支持 PayPay 的影院，从数据行中也剔除 PayPay 值。DEV-14700
          data: this.hasPayPay
            ? this.ticketTable.nextScheduleRecords
            : filterPayPayData(this.ticketTable.nextScheduleRecords),
        },
        paymentMethod: {
          header: [this.paymentMethodTableHeader, this.paymentMethodRefundTableHeader, this.couponReceivableTableHeader,
            this.dayCashSalesHeader, this.paymentTicketItemsHeader],
          data: this.getPaymentMethodData([this.paymentTable, this.paymentRefundTable, this.couponReceivableTable,
            this.dayCashSalesTable, this.paymentTicketItems]),
          isSame: true,
        },
        couponReceive: {
          header: [this.couponReceivableTableHeader, this.dayCashSalesHeader],
          data: this.getCouponData([this.couponReceivableTable, this.dayCashSalesTable]),
          isSame: true,
        },
        shop: {
          header: [this.shopSalesTableHeader, this.shopPaymentTableHeader, this.shopPaymentRefundTableHeader],
          // 售店数据始终带有 paypay 键，因此不支持 PayPay 的影院需剔除，使其与已剔除的表头对齐。DEV-14700
          data: this.hasPayPay
            ? this.getShopData([this.salesTable, this.paymentRecordsTable, this.paymentRefundRecordsTable])
            : filterPayPayData(this.getShopData([this.salesTable, this.paymentRecordsTable, this.paymentRefundRecordsTable])),
          // isSame: true,
        },
        otherRevenue: {
          header: [accountsRecoveryTableHeader(), otherCashRecovery(), accountsPaymentTableHeader(), otherCashPaymentTableHeader(), salesAccountsTableHeader()],
          data: this.getOtherRevenueData([
            this.otherRevenueTable.AccountsRecoveryTable,
            this.otherRevenueTable.CashRecoveryTable,
            this.otherRevenueTable.AccountsPaymentTable,
            this.otherRevenueTable.CashPaymentTable,
            this.otherRevenueTable.SalesAccountsTable,
          ]),
          isSame: true,
        }
      };
      exportCSV_fn(this.cinemaName, data, this.onSearch.searchTime);
    },
    filterHandler(filters) {
      this.ticketFilter = filters;
    },
    getFilmNameFilters(data) {
      return this.$_.uniqBy(data.map(item => ({
        text: item.filmName,
        value: item.filmName,
      })), "text");
    },
    getVersionFilters(data, key) {
      let _arr = [];
      data.forEach(item => {
        if (item[key] && typeof item[key] === "string") {
          item[key].split("、").forEach(version => {
            _arr.push({
              text: version,
              value: version
            });
          });
        }
      });
      return this.$_.uniqBy(_arr, "text");
    },
    getFilteredData(key, data) {
      if(key !== "filmName") {
        return this.ticketFilter[key].length === 0 ? data :
          data.filter(item => this.ticketFilter[key].some(value => item[key].indexOf(value) > -1));
      }
      return this.ticketFilter[key].length === 0 ? data :
        data.filter(item => this.ticketFilter[key].includes(item[key]));
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = this.table1.every(item => !item.otherVersion) ? 3 : 4
      if(rowIndex === this.table1.length - 1) {
        if (columnIndex === 0) {
          return [1, num];
        } else if(columnIndex > 0 && columnIndex < num) {
          return [0, 0];
        }
      }
    },
    arraySpanMethod2({ row, column, rowIndex, columnIndex}) {
      if(rowIndex === this.table2.length - 1) {
        if (columnIndex === 0) {
          return [1, 4];
        } else if(columnIndex > 0 && columnIndex < 4) {
          return [0, 0];
        }
      }
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
      if (rowIndex === this.table1.length - 1 && columnIndex === 0) {
        return {
          "background-color": "#F6E8A4",
          "text-align": "right"
        };
      }
    },
    cellStyle2({row, column, rowIndex, columnIndex}) {
      if (rowIndex === this.table2.length - 1 && columnIndex === 0) {
        return {
          "background-color": "#F6E8A4",
          "text-align": "right"
        };
      }
    },
    isDisplayColumn(prop, tableData) {
      if (tableData.length > 0) {
        const lastIdx = tableData.length - 1
        const lastData = tableData[lastIdx]
        // console.log(lastIdx, tableData[lastIdx])
        // console.log(tableData[lastIdx].scheduleSalesGroup.boxOffice.total)
        if (
          prop === 'otherVersion' && tableData.every(item => !item.otherVersion) ||
          prop === 'scheduleSalesGroup.boxOffice' && lastData && lastData.scheduleSalesGroup.boxOffice.visitor === 0 ||
          prop === 'scheduleSalesGroup.morningShow' && lastData && lastData.scheduleSalesGroup.morningShow.visitor === 0 ||
          prop === 'scheduleSalesGroup.lateShow' && lastData && lastData.scheduleSalesGroup.lateShow.visitor === 0 ||
          prop === 'scheduleSalesGroup.allNight' && lastData && lastData.scheduleSalesGroup.allNight.visitor === 0 ||
          prop === 'scheduleSalesGroup.special' && lastData && lastData.scheduleSalesGroup.special.visitor === 0 ||
          prop === 'scheduleSalesGroup.special' && lastData && lastData.scheduleSalesGroup.special.visitor === 0 ||
          prop === 'seatPrice.before' && lastData && lastData.seatPrice.before.visitor === 0 ||
          prop === 'seatPrice.after' && lastData && lastData.seatPrice.after.visitor === 0 ||
          ((prop === 'officeBox' &&
          (lastData && lastData.officeBox.todayCash.visitor === 0 &&
          lastData && lastData.officeBox.todayCredit.visitor === 0 &&
          lastData && lastData.officeBox.todayPayPay.visitor === 0 &&
          lastData && lastData.officeBox.beforeCash.visitor === 0 &&
          lastData && lastData.officeBox.beforeCredit.visitor === 0 &&
          lastData && lastData.officeBox.beforePayPay.visitor === 0
          ))) ||
          ((prop === 'online' &&
          (lastData && lastData.online.today.visitor === 0&&
          lastData && lastData.online.before.visitor === 0
          ))) ||
          ((prop === 'advanceTicket' &&
          (lastData && lastData.advanceTicket.today.visitor === 0 &&
          lastData && lastData.advanceTicket.before.visitor === 0
          ))) ||
          ((prop === 'nationalTicket' &&
          (lastData && lastData.nationalTicket.today.visitor === 0 &&
          lastData && lastData.nationalTicket.before.visitor === 0
          ))) ||
          ((prop === 'coupon' &&
          (lastData && lastData.coupon.today.visitor === 0 &&
          lastData && lastData.coupon.before.visitor === 0
          ))) ||
          ((prop === 'invitation' &&
          (lastData && lastData.invitation.today.visitor === 0 &&
          lastData && lastData.invitation.before.visitor === 0
          )))
          // ||
          // prop === 'dayNon' && (!lastData || (lastData && lastData.dayNon === 0)) ||
          // prop === 'dayZero' && (!lastData || (lastData && lastData.dayZero === 0)) ||
          // prop === 'dayEight' && (!lastData || (lastData && lastData.dayEight === 0)) ||
          // prop === 'dayTen' && (!lastData || (lastData && lastData.dayTen === 0)) ||
          // prop === 'dayTotal' && (!lastData || (lastData && lastData.dayTotal === 0)) ||
          // prop === 'monthNon' && (!lastData || (lastData && lastData.monthNon === 0)) ||
          // prop === 'monthZero' && (!lastData || (lastData && lastData.monthZero === 0)) ||
          // prop === 'monthEight' && (!lastData || (lastData && lastData.monthEight === 0)) ||
          // prop === 'monthTen' && (!lastData || (lastData && lastData.monthTen === 0)) ||
          // prop === 'monthTotal' && (!lastData || (lastData && lastData.monthTotal === 0))
          ) {
          return false
        }
        return true
      } else {
        return true
      }
    }
  },
  components: {
    CommDatePicker,
  },
  computed: {
    table1() {
      if (!this.$_.isEmpty(this.ticketFilter)) {
        const [ key ] = Object.keys(this.ticketFilter);
        return this.getFilteredData(key, this.ticketTable.todayScheduleRecords);
      }
      return this.ticketTable.todayScheduleRecords;
    },
    table2() {
      if (!this.$_.isEmpty(this.ticketFilter)) {
        const [ key ] = Object.keys(this.ticketFilter);
        return this.getFilteredData(key, this.ticketTable.nextScheduleRecords);
      }
      return this.ticketTable.nextScheduleRecords;
    }
  },
};
</script>
<style lang="less" scoped>
.tableTitle {
  font-size: 20px;
  letter-spacing: 0.9px;
  color: #181818;
}
.table-container {
  width: 100%;
  overflow-x: auto;
  display: flex;
  margin-bottom: 70px;
  >div {
    margin-right: 50px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.std{
  ::v-deep td, ::v-deep th, ::v-deep .cell {
    padding: 0 !important;
  }
  ::v-deep td p {
    margin: 0 !important;
  }
  ::v-deep .el-table {
    margin-bottom: 2px;
  }
  ::v-deep p {
    margin: 1px 0;
  }
}
</style>
